module.exports = __webpack_public_path__ + "static/media/headset.08dc837b.svg";